<h2>EDIZIONE 2021</h2>
<div id="winner">
	<p>Il vincitore della competizione di quest'anno è il team Pwnycorn flying di Padova!</p>
</div>
<div id="istruzioni">
	<h3>Istruzioni</h3>
	<ul>
		<li>Le Cryptowars2021 si svolgono dal 25 al 30 Ottobre 2021.</li>
		<!-- <li>Inizio iscrizione dei team: 19 Ottobre 2021.</li> -->
		<li>Fine iscrizione dei team: 23 Ottobre 2021.</li>
		<li>Inizio gara: 25 Ottobre 2021 ore 14:00 (Milano).</li>
		<li>Fine gara: 30 Ottobre 2021 ore 23:59 (Milano).</li>
		<li>Sono ammessi alla gara team composti da un massimo di 5 studenti. Con "studenti"
			intendiamo iscritti a: laurea, laurea triennale, laurea magistrale e neolaureati
			(nel 2021).</li>
		<li>Il team partecipante deve essere identificato con un unico indirizzo e-mail. Per
			iscriversi bisogna inviare una email a cryptowars_decifris&#64;di.unimi.it, avente come
			oggetto la parola ISCRIZIONE. Nel messaggio di posta elettronica devono comparire:
			<ul>
				<li>il nome del team e l'unico indirizzo e-mail di riferimento dello stesso,</li>
				<li>il nome di ogni singolo partecipante, la sua università di provenienza
					dei singoli, la sua mail.</li>
			</ul>
			<b>ATTENZIONE</b>: tutti i membri del team devono essere iscritti alla nostra
			mailing list prima di inviare il messaggio.
		</li>
		<li>Le soluzioni devono essere inviate allo stesso indirizzo usato per l'iscrizione
			nel formato specificato nel file della challenge. Solitamente in formato .TXT.</li>
		<li>Dal 25 al 30 Ottobre, i partecipanti alle CRYPTOWARS possono inviare SOLO UNA
			soluzione al medesimo quesito.</li>
		<li>Ad ogni domanda è associato 1 punto. I vari team acquisiscono punti in maniera
			incrementale risolvendo le sfide e inviando le risposte corrette. Se alla fine della
			gara piu' team hanno ottenuto lo stesso punteggio, controllando data e ora
			della soluzione consegnata via email, viene dichiarato vincitore chi ha
			svolto le sfide nel minor tempo.</li>
		<!--

			<li><a href="../../../../../../assets/attivita/cryptowars/2021/
				cryptowars2021.pdf">Locandina</a>.</li>
			<li><a href="../../../../../../assets/attivita/cryptowars/2021/Cryptowars2021.zip">
				Sfide 2021.</a></li>
				-->
	</ul>
</div>
<div id="FAQ">
	<h3>FAQ</h3>
	<ul>
		<li><i>Devo personalmente implementare del codice per risolvere i quesiti? </i><br>
			Non è richiesto di inviare il codice usato, quindi una via semplice è quella di
			cercare del codice già implementato. Resta il fatto che, siccome la gara ha soprattutto
			lo scopo di portare alla comprensione profonda di problemi crittografici, si consiglia
			di lavorare in maniera autonoma al proprio codice e alla sua ottimizzazione.<br>
		</li>
		<li><i>Devo pensare e implementare nuovi attacchi?</i><br>
			Non necessariamente. Esistono molti attacchi noti in letteratura, quindi cercane uno che
			ti sembra semplice da capire, implementalo e mandalo in esecuzione!</li>
	</ul>
</div>
<div id="news">
	<h3>News</h3>
	<ul>
		<li>
			[01/10/2021]
			Annuncio delle Cryptowars 2021. Buon divertimento!!
		</li>
		<li>
			[25/10/2021]
			I team iscritti alla competizione sono 6 e provengono da: Milano, Cagliari, Torino e Padova.
		</li>
		<li>
			[25/10/2021]
			Ore 14, abbiamo dato il via alla competizione.
		</li>
		<li>
			[30/10/2021]
			Ore 23:59, abbiamo chiuso la competizione.
		</li>
		<li>
			[10/11/2021] Ecco la classifica finale delle cryptowars 2021:<br>
			<ol>
				<li>Pwnycorn flying (Padova)</li>
				<li>pwnthem0le (Torino)</li>
				<li>Assenteisti Anonimi (Milano)</li>
				<li>Srdnlen (Cagliari)</li>
				<li>RSAlty (Milano)</li>
				<li>K!nd4sus (Milano)</li>
			</ol>
		</li>
	</ul>
	<p>Complimenti a tutti i partecipanti!</p>
</div>
<!-- <div id="premiazioni">
		<h3>Premiazioni</h3>
		<p>
			La premiazione dei terzi classificati è avvenuta in data 20 maggio 2021, durante la presentazione
			del seminario <i>"Strumenti per fare crittoanalisi nei grafi di isogenie supersingolari"</i>.
			La premiazione dei secondi e primi classificati avverrà durante il <a href="
			https://sites.google.com/view/crittografiaecodici/convegno-annuale">convegno annuale</a>, 
			in data 22 settembre 2021.
		</p>
	</div> -->